import { TestimonialSlider } from '../../__utils/sliders';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        TestimonialSlider.init();
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
